<template>
    <b-row>
	
        <b-col>
            <b-overlay :show="attrs_wait">
                <div v-if="! data.fixed && !not_editable && check_roles([ 'model' ])" class="mb-2 d-flex" style="gap: .5rem;">
                    <v-select clearable v-model="attr_id" :reduce="obj => obj.id" label="name" :options="attrs_visible" clearSearchOnSelect required placeholder="Ценообразующий фактор" style="flex: 1;"/>

                    <b-button v-if="attr_id != null" size="sm" variant="outline-primary" v-on:click="() => add_attr()"><base-icon name="add"/></b-button>
                </div>

                <b-table ref="variables" class="variables" style="font-size: 10pt;" small sort-by="ind" :items="showed_attrs" :fields="attrs_fields" selectable select-mode="single" selected-variant="primary" v-on:row-selected="select_attr">

					<template v-slot:head(settings)>

						<base-icon name="settings" />

					</template>

					<template v-slot:cell(settings)="data">

						<b-button variant="outline-primary-dark" size="sm" @click="() => delete_one(data.item.id)">

							<base-icon name="delete" />

						</b-button>

					</template>

                    <template v-slot:cell(type)="data">

                        <div v-if="data.item.type == 'number'">Количественный</div>
                        <div v-else>Качественный</div>

                    </template>

                    <template #cell(expand)="attr_details">
                        <b-button v-if="attr_details.item.type != 'number'" class="filter-button" variant="light" @click="attr_details.toggleDetails">
                            <base-icon :name="attr_details.detailsShowing ? 'double_arraow_top' : 'double_arraow_bottom'"/>
                        </b-button>
                    </template>

                    <template v-slot:row-details="row_data">
						<attr_reference :row_data="row_data" :id="id" :data="data" v-on:edit="ev => $emit('edit', ev)" :not_editable="not_editable" v-on:need_refresh="refresh_group_attr_reference" />
                    </template>

                </b-table>

            </b-overlay>

        </b-col>

        <b-col v-if="selected_attrs.length && plot && plot.length > 1 && plot[1][1] != null">

            <GChart class="mt-2" type="ColumnChart" :settings="{ packages: [ 'corechart' ], language: 'en' }" :options="attr_stat_column_options" :data="plot"/>

        </b-col>

    </b-row>
</template>

<script>
import api from '../../../../../../../api'
import format_expanded_value from "./format_expanded_value"
import attrs from "../../../../../../../api/attrs"
import attr_reference from './attr_reference'
import o from "./../../objects"
import { GChart } from "vue-google-charts"
import variables from '../../../../../../../api/variables'

export default {
    props :
    {
        id : String,
		group_id : String,
		data : Object,
		not_editable : Boolean
    },

    components :
    {
		attr_reference,
		GChart,
    },

    data()
    {
        return {
			attrs : [],
			showed_attrs : [],
			attrs_visible : [],

            attr_id : null,
			selected_attrs : [],

			plot : null,
			attrs_wait : false,
            
            attr_stat_column_options :
			{
				legend : { position : "none" },
				annotations : { alwaysOutside : true },
				vAxis : {
					viewWindow : { max : 0 },
					format: "#"
				},
				tooltip: { isHtml: true }
			},
			// attr_stat_pie_options : { legend : { position : "right", textStyle : { fontSize : 14 } }, chartArea : { width : "100%", height : "90%" }},
        }
    },

	beforeMount()
	{
		o.objects().bus.$on("update_plots",
			() =>
			{
				this.showed_attrs.forEach(attr => this.show_attr(attr, true, attr))
				this.$refs.variables.clearSelected()
			})

		attrs.get(this).then(
			desc =>
			{
				this.attrs = desc.attrs.filter(attr => ! attr.not_real && attr.is_factor && ( attr.type == "number" || ( attr.name != "bad" && attr.type == "bool" ) || ( attr.type == "str" && attr.reference != null ) ))
				this.update_attrs_visible()
			})
	},

	watch :
	{
		data :
		{
			immediate : true,
			deep : true,

			handler(data)
			{
				if(data && data.attrs && data.attrs_indexes)
				{
					var showed_attrs = []

					data.attrs.forEach(
						attr =>
						{
							var showed_attr = this.showed_attrs.find(sattr => sattr.id == attr.id)

							attr.ind = data.attrs_indexes[attr.id]

							if(showed_attr)
							{
								showed_attr.ind = attr.ind
								showed_attrs.push(showed_attr)
							}
						})

					if(this.showed_attrs)
						this.showed_attrs = api.sort_objects_array_by_key(showed_attrs, "ind")
				}

				this.data = data
				this.update(true)
			},
		}
	},

    computed :
    {
        attrs_fields()
		{
			let fields = [
				{ key : "ind", label : "X", thStyle : "min-width: 60px;" },
				{ key : "name", label : "Ценообразующий фактор" },
				{ key : "type", label : "Тип ценообразующего фактора", thStyle : "min-width: 100px;" },
			]

			if (! this.data.fixed && !this.not_editable && this.check_roles([ 'model' ]))
			{
				fields.unshift({
					key : "settings",
					label : "",
					thClass: "cell_settings_head",
					thStyle: "width: 64px;"
				})
			}
			
			if (this.showed_attrs.find(attr => attr.type != "number"))
			{
				fields.unshift({ key : "expand", label : "", tdClass : ['expand'] })
			}

			if (!this.data.fixed)
			{
				fields.push(
					{ key : "correlation", label : "Корреляция", thStyle : "min-width: 100px;", tdClass : "text-right" },
					{ key : "confidence", label : "Доверительный интервал", thStyle : "min-width: 100px;", tdClass : "text-right" }
				)
			}

			return fields
		}
    },

    methods :
    {
        check_roles(roles)
		{
			return api.check_roles(this, roles)
		},

		update(only_refresh_stat)
		{
			if(! only_refresh_stat)
			{
				this.attrs_wait = true
				Promise.all(this.data.attrs.map(attr => this.show_attr(attr)))
					.then(() => this.attrs_wait = false)
			}

			this.showed_attrs.forEach(
				attr =>
				{
					attr.confidence = this.data.attrs_confidences[attr.id]
					attr.confidence = attr.confidence == null ? 0 : api.round3(attr.confidence)
				})
		},
		
		show_attr(attr, update_showed_attr = false, showed_attr = null)
		{
			if(showed_attr == null)
				showed_attr = this.showed_attrs.find(_attr => _attr.id == attr.id)

			if(update_showed_attr)
				attr = showed_attr
			else if( showed_attr != null )
				return

			return api.call(this, "cadastral_groups", "get_analogues_statistics", { id : this.group_id, attr : attr.id },
				response =>
				{
					attr.median = response.median
					attr.correlation = api.round3(response.correlation)

					function get_row(label, value) {
						const _str = value == 0 || value == null ? value : api.number_to_string_with_ranking(value)
						return [ label, value, _str, api.get_tooltip(label, "Значение", _str) ]
					}

					attr.plot =
					[
						[ "Статистика", "Значение", { role : "annotation", type : "string" }, { role : "tooltip", p: {html: true} }  ],
						get_row("Минимальное", response.min),
						get_row("Среднее", response.average),
						get_row("Среднее медианное", response.median),
						get_row("Максимальное", response.max),
					]

					attr.confidence = this.data.attrs_confidences[attr.id]
					attr.confidence = attr.confidence == null ? 0 : api.round3(attr.confidence)

					var histogram

					if(attr.type != "number")
					{
						var histogram_raw = []

						histogram = [ [ "Значение", "Уровень цен", { role : "annotation" }, { role : "tooltip", p: {html: true} } ] ]

						// attr_reference != null, если ЦОФ был только что добавлен
						if(attr.attr_reference == null)
							attr.attr_reference = this.data.attrs_references[attr.id].values

						response.histogram.forEach(
							elem =>
							{
								if(attr.attr_reference[elem[0]])
									elem.push(attr.attr_reference[elem[0]].code)
							})

						response.histogram = api.sort_objects_array_by_key(response.histogram, 2)

						response.histogram.forEach(
							desc =>
							{
								const value = desc[0]
								const uprs = desc[1]
								const count_ind = response.histogram_count.findIndex(elem => elem[0] == desc[0])
								const count = response.histogram_count[count_ind][1]
								const attr_reference = attr.attr_reference[value]

								if(attr_reference == null)
									return

								const code = attr_reference.code
								const default_value = attr_reference.default
								const hr_ind = histogram_raw.length - 1

								if(hr_ind >= 0 && histogram_raw[hr_ind].code == code)
								{
									const count_sum = histogram_raw[hr_ind].count + count

									histogram_raw[hr_ind].uprs = ( ( histogram_raw[hr_ind].uprs * histogram_raw[hr_ind].count ) + ( uprs * count ) ) / count_sum
									histogram_raw[hr_ind].count = count_sum

									histogram[histogram.length - 1][1] = histogram_raw[hr_ind].uprs
									histogram[histogram.length - 1][2] = histogram_raw[hr_ind].uprs == 0 ? histogram_raw[hr_ind].uprs : api.format_cost(histogram_raw[hr_ind].uprs)
									histogram[histogram.length - 1][3] = api.get_tooltip(
										histogram[histogram.length - 1][0],
										"Уровень цен",
										histogram_raw[hr_ind].uprs == 0 ? histogram_raw[hr_ind].uprs : api.format_cost(histogram_raw[hr_ind].uprs)
									)
								}
								else
								{
									histogram.push([
										default_value,
										uprs,
										uprs == 0 ? uprs : api.format_cost(uprs),
										api.get_tooltip(default_value, "Уровень цен", uprs == 0 ? uprs : api.format_cost(uprs))
									])
									histogram_raw.push({ default_value : default_value, uprs : uprs, count : count, code : code })
								}
							})

						this.update_attr_reference_expanded(attr)
					}

					attr.histogram_raw = response.histogram
					attr.histogram = histogram

					if(histogram != null)
						o.attrs_histogram[attr.id] = histogram.slice(1).map(row => row[0])

					if(! update_showed_attr)
						this.showed_attrs.push(attr)

					this.update_attrs_visible()

					return response.histogram
				})
		},

		update_attr_reference_expanded(attr)
		{
			attr.attr_reference_expanded = Object.entries(attr.attr_reference).map(
				desc => {
					if (!this.data.fixed)
					{
						return new Object({
							value : format_expanded_value(desc[0], attr),
							default : format_expanded_value(desc[1].default),
							code : desc[1].code,
						})
					}
					else
					{
						return new Object({
							value : format_expanded_value(desc[0], attr),
							default : format_expanded_value(desc[1].default),
							code : desc[1].code,
							formula_value : this.data.params[variables.CE_modeling_model.getCodeByName(this.data.type)][api.attr_key_without_attrs(attr)][desc[0]].value,
						})
					}
				}
			)
		},

		update_attrs_visible()
		{
			this.attrs_visible = this.attrs.filter(attr => 
				this.showed_attrs.find(sattr => attr.id == sattr.id) == null
			)
		},

		refresh_plot(attr)
		{
			const func = attr.type == "bool" ? ( value => ( typeof value == "boolean" && value ) || ( value == "Да" || value == "true" ) ? "Да" : "Нет" ) : ( value => value )
			var min_value = null
			var max_value = 0

			this.plot = attr.type == "number" ? attr.plot : attr.histogram

			this.plot.slice(1).forEach(
				row =>
				{
					if(row[1] > max_value)
						max_value = row[1]

					if(min_value == null || row[1] < min_value)
						min_value = row[1]

					row[0] = func(row[0])
				})

			this.attr_stat_column_options.vAxis.viewWindow.max = max_value + 0.8 * ( max_value - min_value ) // Чтобы alwaysOutside работало
		},

		// ####################### Добавление/удаление факторов #############################

        select_attr(attrs)
		{
			if(attrs.length == 0)
			{
				this.selected_attrs = []

				return
			}

			this.selected_attrs = attrs

			this.refresh_plot(attrs[0])
		},

        add_attr(attr_id = null, save_operation_in_history = true)
		{
			if(attr_id == null)
			{
				attr_id = this.attr_id
				this.attr_id = null

				if(this.data.model_imported || ! o.objects().check_m_criteria(this.data.attrs.length + 1))
					return
			}

			this.attrs_wait = true

			api.call(this, "cadastral_groups", "check_attr_is_able_for_modeling", { id : this.group_id, attr : attr_id },
				() =>
				{
					var attr = this.attrs.find(attr => attr.id == attr_id)
					var attr_ids = []
					var promise = new Promise(resolve => resolve(true))

					this.showed_attrs.forEach(attr => attr_ids.push(attr.id))
					attr_ids.push(attr.id)

					var fields = { "modeling.attrs" : attr_ids }

					promise = new Promise(
						resolve =>
							api.call(this, "cadastral_groups", "get_analogues_statistics", { id : this.group_id, attr : attr.id },
								response =>
								{
									if(attr.type == "number")
									{
										const key_confidence = `modeling.attrs_confidences.${attr.id}`

										fields[key_confidence] = response.confidence
										this.data.attrs_confidences[attr.id] = response.confidence
									}
									else
									{
										var code = 0
										var values_existed = new Set()

										response.histogram = api.sort_objects_array_by_key(response.histogram, 1, true)
										attr.attr_reference = {}

										response.histogram.forEach(
											desc =>
											{
												const value = desc[0]

												attr.attr_reference[value.toString()] = { default : format_expanded_value(value, attr), code : code.toString() }
												values_existed.add(value)

												code ++
											})

										/*
										   3716 - #73
										var all_values = ( attr.reference == null ) ? [ true, false ] : attr.reference.values

										all_values.forEach(
												value =>
												{
													if(! values_existed.has(value))
													{
														attr.attr_reference[value.toString()] = { default : format_expanded_value(value, attr), code : code.toString() }

														code ++
													}
												})
										 */

										const key = `modeling.attrs_references.${attr.id}.values`

										fields[key] = attr.attr_reference
										this.data.attrs_references[attr.id] = { values : attr.attr_reference }
									}

									resolve(true)
								})
						)

					promise.then(
						() =>
						{
							this.$emit("edit", { fields : fields, save_operation_in_history : save_operation_in_history })
							o.objects().bus.$emit("attrs_changed", { ids : attr_ids, attrs_references : this.data.attrs_references })

							this.show_attr(attr).then(() => this.attrs_wait = false)
						})
				},
				( self, response ) =>
				{
					api.show_notification(this, response.description)

					this.attrs_wait = false 
				})
		},
		
		delete_one(attr_id)
		{
			const message = "Вы действительно хотите удалить ценообразующий фактор из модели?"

			this.$bvModal.msgBoxConfirm(message,
				{
					title : "Подтверждение удаления",
					okVariant : "danger",
					okTitle : "Да",
					cancelVariant : "outline-primary-secondary",
					cancelTitle : "Нет",
					hideHeaderClose : false,
					centered : true
				})
				.then(
					value =>
					{
						if(value)
							this.delete_attr(attr_id)
					})
		},

        delete_attr(attr_id, save_operation_in_history = true)
		{
			this.attrs_wait = true

			var attr_ids = []

			this.showed_attrs = this.showed_attrs.filter(sattr => sattr.id != attr_id)
			this.showed_attrs.forEach(attr => attr_ids.push(attr.id))

			// При удалении нет смысла удалять соответствующую attrs_reference из data

			api.call(this, "cadastral_cost_evaluation", "unset_field", { id : this.id, field : `modeling.attrs_references.${attr_id}` },
				() =>
				{
					this.$emit("edit", { fields : { "modeling.attrs" : attr_ids }, save_operation_in_history : save_operation_in_history })
					o.objects().bus.$emit("attrs_changed", { ids : attr_ids })
					
					this.update_attrs_visible()
					this.attrs_wait = false
				})
		},

		// ####################### Группировка факторов ####################################

		refresh_group_attr_reference(attr)
		{
			this.show_attr(attr, true).then(
				() =>
				{
					this.refresh_plot(attr)
					// this.selected_attr_reference_row.toggleDetails()
					// this.selected_attr_reference_row.toggleDetails()

					o.objects().bus.$emit("refresh_plots")
				})
		}
    }

}
</script>

<style scoped>
* >>> .cell_settings_head
{
	text-align: center;
}

* >>> .variables tbody tr > .expand
{
    padding : 0 !important;
    width: 46px;
}
</style>
